import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const CustomDatePicker = ({ value, ...props }) => {
  const dateValue = value ? dayjs(value) : null;
  return <DatePicker style={{ width: "100%" }} value={dateValue} placeholder="Сонгоно уу" {...props} />;
};

export default CustomDatePicker;
